import React, { ReactElement } from 'react';
import LoadingIndicator from '@src/components/LoadingIndicator';

export default function Loader(): ReactElement {
  return <LoadingIndicator loading={true} />;
}
